// wishlistUtils.js - Utility functions for wishlist operations

import axiosInstance from '../axiosInstance';

/**
 * Move an item from a wishlist to a collection
 * @param {string} collectionType - Type of collection ('games', 'consoles', 'lego', 'movies', 'music')
 * @param {string} itemId - ID of the item to move
 * @returns {Promise} Promise that resolves with the moved item data
 */
export const moveToCollection = async (collectionType, itemId) => {
  try {
    let endpoint;
    
    console.log(`moveToCollection called with collectionType: ${collectionType}, itemId: ${itemId}`);
    
    switch (collectionType) {
      case 'game-wishlist':
        endpoint = `/game-wishlist/move-to-collection/${itemId}`;
        break;
      case 'console-wishlist':
        endpoint = `/console-wishlist/move-to-collection/${itemId}`;
        break;
      case 'lego-wishlist':
        endpoint = `/lego-wishlist/move-to-collection/${itemId}`;
        break;
      case 'movie-wishlist':
        endpoint = `/movie-wishlist/move-to-collection/${itemId}`;
        break;
      case 'music-wishlist':
        endpoint = `/music-wishlist/move-to-collection/${itemId}`;
        break;
      case 'book-wishlist':
        endpoint = `/book-wishlist/${itemId}/move-to-collection`;
        break;
      case 'board-game-wishlist':
        endpoint = `/board-game-wishlist/${itemId}/move-to-collection`;
        break;
      default:
        throw new Error(`Unsupported collection type: ${collectionType}`);
    }
    
    console.log(`Making API request to endpoint: ${endpoint}`);
    
    try {
      const response = await axiosInstance.post(endpoint);
      console.log(`API request successful:`, response.data);
      return response.data;
    } catch (apiError) {
      console.error(`API request failed:`, apiError);
      console.error(`API response:`, apiError.response?.data);
      console.error(`API status:`, apiError.response?.status);
      throw apiError;
    }
  } catch (error) {
    console.error(`Error moving item from ${collectionType} to collection:`, error);
    throw error;
  }
};

/**
 * Add a move-to-collection button to the CollectionPage component
 * @param {Object} props - Component props
 * @param {string} props.collectionType - Type of collection
 * @param {Object} props.item - Item to add the button for
 * @param {Function} props.onMoveSuccess - Callback function to call when move is successful
 * @returns {JSX.Element} Move to collection button
 */
export const MoveToCollectionButton = ({ collectionType, item, onMoveSuccess }) => {
  // This is a placeholder for a React component that would be implemented
  // in a separate file. The actual implementation would depend on the UI library
  // and design system being used.
  return null;
};
